 
<input type="text" #msg>
<button type="button" (click)="sendMessage(msg.value)" value="Send Event">Send Event</button>